<template>
  <div>
    <img src="~images/50jahre.gif" class="md:h-32" alt="Jubiläum" />
  </div>
</template>

<script>
export default {}
</script>
